<template>
  <div class="language-switcher">
    <select v-model="currentLocale" @change="changeLanguage" class="language-select">
      <option value="zh">中文</option>
      <option value="en">English</option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { analytics } from '../utils/analytics'

const { locale } = useI18n()
const currentLocale = ref(locale.value)

onMounted(() => {
  // 从localStorage读取保存的语言设置
  const savedLocale = localStorage.getItem('color-extractor-locale')
  
  if (savedLocale && ['zh', 'en'].includes(savedLocale)) {
    // 如果有保存的语言设置，使用保存的设置
    currentLocale.value = savedLocale
    locale.value = savedLocale
  } else {
    // 如果没有保存的语言设置，根据浏览器语言自动设置
    const browserLang = navigator.language.toLowerCase()
    let detectedLocale = 'zh' // 默认中文
    
    if (browserLang.includes('en')) {
      detectedLocale = 'en'
    } else if (browserLang.includes('zh')) {
      detectedLocale = 'zh'
    }
    
    // 设置检测到的语言
    currentLocale.value = detectedLocale
    locale.value = detectedLocale
    localStorage.setItem('color-extractor-locale', detectedLocale)
    
    // 跟踪自动语言检测事件
    analytics.trackEvent('language_auto_detected', {
      event_category: 'user_preference',
      event_label: 'browser_language_detected',
      detected_language: detectedLocale,
      browser_language: navigator.language
    })
  }
})

function changeLanguage() {
  const oldLocale = locale.value
  locale.value = currentLocale.value
  localStorage.setItem('color-extractor-locale', currentLocale.value)
  
  // 跟踪语言切换事件
  analytics.trackLanguageSwitch(oldLocale, currentLocale.value)
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
}

.language-select {
  padding: 0.5rem 1rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: white;
  color: #495057;
  font-size: 0.9rem;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.language-select:hover {
  border-color: #667eea;
}

.language-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}
</style>
